import { useNavigate } from 'react-router-dom';
import { NavigationItem } from './NavigationItem';
import { NavigationItem as NavItem } from '../../hooks/useNavigation';
import { useNavigationState } from '../../hooks/useNavigationState';
import { useAuth } from '../../hooks/useAuth';

interface NavigationListProps {
  items: NavItem[];
  isSidebarCollapsed: boolean;
}

export function NavigationList({ items, isSidebarCollapsed }: NavigationListProps) {
  const navigate = useNavigate();
  const { isItemActive, isItemAccessible, isItemVisible } = useNavigationState();
  const { isAuthenticated } = useAuth();

  const handleNavItemClick = (e: React.MouseEvent, item: NavItem) => {
    const isAccessible = isItemAccessible(item);

    // In unauthenticated preview, any click redirects to login
    if (!isAuthenticated) {
      e.preventDefault();
      navigate('/login');
      return;
    }

    if (!isAccessible) {
      e.preventDefault();
      navigate('/account?tab=subscription');
    }
  };

  return (
    <>
      {items.map((item) => {
        if (!isItemVisible(item)) {
          return null;
        }

        return (
          <NavigationItem
            key={item.href}
            item={item}
            isActive={isItemActive(item)}
            isAccessible={isItemAccessible(item)}
            isSidebarCollapsed={isSidebarCollapsed}
            onClick={handleNavItemClick}
          />
        );
      })}
    </>
  );
}
